import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
	selector: 'app-confirm-email',
	templateUrl: './confirm-email.component.html'
})
export class ConfirmEmailComponent implements OnInit {
	registerForm: FormGroup;
	confirmPassword: string;
	passwordMatch: boolean;

	messages: Message[] = [];
	email: string;
	token: string;

	showForm = true;

	constructor(
		private profileService: ProfileService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {}

	clearMessages() {
		this.messages.length = 0;
	}

	setMessage(msg: Message) {
		this.clearMessages();
		this.messages.push(msg);
	}

	onConfirmPassword() {
		const password = this.registerForm.get('password').value;
		this.passwordMatch = this.confirmPassword === password;
	}

	ngOnInit() {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.email = params.email;
			this.token = params.token;
			this.registerForm = new FormGroup({
				password: new FormControl(null, Validators.required)
			});
		});
	}

	onSaveForm() {
		let registerForm = this.registerForm.value;
		this.showForm = false;
		this.profileService.completeRegistration(this.email, this.token, registerForm).subscribe(
			(result) => {
				this.profileService.registrationSuccessful = true;
				this.router.navigate([ '/registration-success' ], { state: { isCompletion: true } });
			},
			(error) => {
				this.showForm = true;
				if ('errorMessage' in error.error) {
					this.setMessage({
						severity: 'error',
						detail: error.error['errorMessage']
					});
				}
			}
		);
	}

	showView() {
		return this.showForm && this.registerForm !== undefined && this.email !== undefined && this.token !== undefined;
	}

	onBackToLogin() {
		this.router.navigate([ '/login' ]);
	}
}
